import { all } from "redux-saga/effects";
import { GeneralSaga } from "./saga/GeneralSaga";

function* rootSaga() {
  yield all([GeneralSaga()]);
}

export default rootSaga;
